import withHelmet from '../HOC/withHelmet';
import ReferAFriendPage from '../components/refer-a-friend';

export default withHelmet(
  ReferAFriendPage,
  'Refer a Friend Terms and Conditions',
);
